module.exports = __webpack_public_path__ + "media/images/about/a4-b0ceb745f660451418b7770b23e7e4ed.png";